import { api } from './client'

const activityService = {
  getActivities: async ({ limit = 500, offset = 0 } = {}) => {
    const resp = await api.get('/activities', { limit, offset })
    return { activities: resp.data, total: resp.meta.total }
  },

  getActivity: async (activityId) => {
    const resp = await api.get(`/activities/${activityId}`)
    return resp.data
  },

  createActivity: async (data) => {
    const resp = await api.post('/activities', data)
    return resp.data
  },

  updateActivity: async (activityId, data) => {
    const resp = await api.put(`/activities/${activityId}`, data)
    return resp.data
  },
}

export default activityService
